var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-view',[_c('div'),_c(_vm.componenteAtivo,{tag:"component",attrs:{"filters":_vm.filters,"cliente":_vm.cliente,"origem":_vm.rotaDeOrigem},on:{"limpar-origem":_vm.limparOrigem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }